import { TireSeason } from '@navio/nsdk';

/**
 * Whether the offer's tires are the ones the car drives on now. Winter runs October through March: the tire changes
 * fall in October and April, so an offer made at the change is for the tires that just came off.
 */
export const isTireSeasonNow = (season: TireSeason, now = new Date()) => {
  if (season === TireSeason.ALL_SEASON) {
    return true;
  }
  const month = now.getMonth();
  const isWinterNow = month >= 9 || month <= 2;
  return (season === TireSeason.WINTER) === isWinterNow;
};
